import ACustomTemplateCate from './service';
export default {
    ACustomTemplateCate
};